import React, { useState, useEffect } from "react";
import "./support.css";
import Header from "../../components/Navbar";
import Support from "../../myimgs/Vector (2).png";
import Footer from "../../components/footer/footer";

export default function SupportHero() {
  const articles = [
    {
      question: "How can I make an offer on a property?",
      answer:
        "To place an offer on any property listed on Twoffers, you’ll first need to create an account on our platform. Once registered, simply visit the property details page, enter your offer amount, and click on “Submit Offer.",
    },
    {
      question: "How do I register with Twoffers?",
      answer:
        "Getting started is quick and easy! Just click the “Register” button at the top-right corner of our website, fill out the registration form, and submit your details. Once registered, you can start exploring and making offers on properties instantly.",
    },
    {
      question: "How do Twoffers work?",
      answer: "Twoffers conducts a secure offer submission process where buyers submit their offers within a set timeframe. The seller reviews all offers and chooses the one they wish to accept. (No public live   Offer.)",
    },
    {
      question: "How does navigation work on Twoffers.com?",
      answer: "If you need help navigating the platform or submitting your offer, our support team can guide you step-by-step.",
    },
    {
      question: "What is Proof of Funds and why is it required?",
      answer:
        "The Proof of Funds (POF) is a document or verification process that confirms you have enough financial resources to complete the property purchase. At Twoffers, this step helps assure sellers that you’re a serious and qualified buyer who can successfully close the deal. Providing proof of funds builds trust between both parties and speeds up the transaction process.",
    },
    {
      question: "How long is the Offer deposit hold?",
      answer:
        "Once your offer is accepted, the deposit is held in trust (by either the buyer’s or seller’s lawyer). A service charge may apply at the time the offer is accepted.",
    },

    {
      question: "What is the deposit money requirements?",
      answer:"There is no Deposit money required upfront. After confirming the offer with seller you only need to require to Pay $1000 as Deposit Ammount"
         },
    {
      question: "What is a APS? Which details are required for this?",
      answer:"If the transaction is done through Twoffers , The buyer’s lawyer or the buyer’s agent can draft the APS."
        },

    {
      question: "What is Auto Offer?",
      answer:"No verbal or informal offers all offers must be formally submitted , No wired Offer amounts ,	All offer amounts must be stated clearly and submitted properly within the platform rules."
         },
  ];

  const [activeArticle, setActiveArticle] = useState(null);

  //   menuaccordion ..
  const [activeTab, setActiveTab] = useState("General");
  const [activeSidebar, setActiveSidebar] = useState("");
  const [activeAccordion, setActiveAccordion] = useState(null);
  //   menuaccordion ..

  //   menusjjlll
  // Sidebar options based on selected tab
  const sidebarData = {
    General: [
      "About Twoffers",
      "My Account",
      "Twoffers Preview Properties",
      "Commercial Properties",
      "Traditional Sales",
      "Non Performing Loans",
    ],
    "Pre   Offer": [
      "Before Your Offer/Offer",
      "Buying Without an Agent",
      "Paying for Your Home",
      "Registration",
      "Search/Favorites",
      "Visiting a Property & Home Inspections",
    ],
    "During   Offer": [
      "Offers",
      "Offer Deposit Hold",
      "Offer Selected/Offer Approved",
    ],
    "Post   Offer": ["Closing", "eSignatures", "Proof of Funds"],
  };
  // Dummy accordion data (replace later with real content)
  const accordionData = {
    "About Twoffers": [
      {
        question:
          "What types of properties are available for sale on Twoffers?",
        answer:
          "Twoffers offers a wide range of properties including studios, single-family homes, multi-family residences (one to four units), condominiums, townhomes, mixed-use properties, mobile homes, and land. Whether you’re looking to buy, invest, or Offer on a property, Twoffers gives you access to diverse options across different property types.",
      },
      {
        question:
          "Are only bank-owned homes and foreclosures marketed on Twoffers?",
        answer:
          "No. In addition to bank-owned homes, Twoffers also features private, non-bank-owned properties, short sales, and pre-foreclosures.",
      },
      {
        question: "What types of homes are marketed on the site?",
        answer:
          "Twoffers lists a variety of homes including bank-owned properties, foreclosures, and short sales available for   Offer or direct purchase.",
      },
      {
        question: "How can I tell if a property is available for purchase?",
        answer:
          "A property is available for purchase if you see a 'Place Offer' button on its property details page.",
      },
      {
        question:
          "Does Twoffers own the homes available for purchase on the site?",
        answer:
          "No. Properties listed on Twoffers are owned by banks or private sellers. Twoffers serves as a trusted marketplace connecting buyers and sellers.",
      },
      {
        question: "Do you have non-bank owned homes on the site?",
        answer:
          "Yes. Twoffers also features non-bank-owned homes that can be purchased or Offer on. To find these properties, simply use the 'Non-Bank Owned' filter in your search options.",
      },
      {
        question: "Who supplies the property details?",
        answer:
          "Property information is generally provided directly by the seller. In some cases, details such as square footage or land size are taken from public records. Buyers are encouraged to verify all property information before making an offer.",
      },
      {
        question:
          "How do I know if a house is offered through an Offer or traditional sale?",
        answer:
          "On the property page, if the button says 'Place Offer' or 'Place Backup Offer', it is an Offer. If it says 'Place Offer' or 'Place Backup Offer', it is a traditional sale.",
      },
      {
        question: "What is the Technology Fee?",
        answer:
          "The Technology Fee helps cover the cost of maintaining and operating Twoffers’ online platform. This fee is added to the purchase price of applicable properties and is clearly mentioned in the Property Fees section of the property details page.",
      },
      {
        question:
          "I am having trouble submitting a Offer or offer online. What should I do?",
        answer:
          "If you experience any issues submitting a Offer or offer, please contact the Twoffers Support Team via email at support@twoffers.com or chat with us live on the website.",
      },
    ],
    "My Account": [
      {
        question: "How do I delete my account on Twoffers?",
        answer:
          "To delete your account on Twoffers, log in to your account and go to the 'My Profile' section. Scroll to the bottom of the page and click on the 'Delete your account' option. You’ll be asked to confirm your decision. Once confirmed, your account will be permanently deleted from Twoffers and cannot be accessed again in the future.",
      },
      {
        question: "Why am I not allowed to delete my account?",
        answer:
          "If you currently have an active transaction on your Twoffers account, you won’t be able to delete it. Once the active transaction period ends and all related activities are completed, the option to delete your account will become available.",
      },
    ],
    "Twoffers Preview Properties": [
      {
        question: "What are Twoffers Preview Properties?",
        answer:
          "Twoffers Preview Properties allow you to see homes that are scheduled to be listed soon. You can track properties you’re interested in and get ready to place your Offer or offer in advance. Click the link to learn more about this program: Twoffers’ Preview Properties.",
      },
    ],
    "Commercial Properties": [
      {
        question:
          "Where can I find details about a specific commercial property?",
        answer:
          "All available information about a commercial property can be found on its property details page and in the documents section. Occasionally, new details or documents may be added during the Offer period. For the most accurate and updated information, we recommend checking the property details page regularly as the Offer progresses.",
      },
      {
        question:
          "How do I access due diligence information for a commercial property?",
        answer:
          "To access key due diligence information, you must register on Twoffers.com and sign a Confidentiality Agreement. Once completed, you’ll gain access to documents on the property details page, where important buyer information is available. Review these materials carefully to ensure you are fully prepared before placing a Offer.",
      },
      {
        question:
          "Will I receive additional information during the Offer process?",
        answer:
          "Yes, during the Offer process, you may be contacted by the listing broker or one of Twoffers’ commercial real estate experts. They can provide additional property details or assist you throughout the Offer process. Stay alert for any communications that can help you make an informed decision.",
      },
      {
        question: "How long is the marketing period for commercial properties?",
        answer:
          "Before the Offer starts, there is typically a marketing period of 15 to 45 days. This gives potential buyers enough time to review information, complete due diligence, and prepare before   Offer begins. Use this time to analyze all available documents and get answers to your questions.",
      },
      {
        question: "Can I place a Offer without completing my due diligence?",
        answer:
          "All Offerders should complete their due diligence before submitting a Offer or offer on Twoffers. Once the Offer ends and a Offer is selected, the winning Offerder must move forward with the closing process. Make sure you are fully prepared before placing your offer.",
      },
      {
        question: "What happens after the Offer ends?",
        answer:
          "If you are the winning Offerder at the end of the Offer, congratulations! A Twoffers representative will contact you to explain the next steps and help you finalize the transaction. Keep an eye on your email or phone for updates.",
      },
      {
        question:
          "Is there anything I need to provide Twoffers before I place a Offer?",
        answer:
          "Yes, you’ll need to provide proof of funds before placing a Offer. This confirms that you have the financial capacity to complete the transaction if your Offer is selected. You can easily upload your proof of funds through the Twoffers platform to ensure a smooth   Offer process.",
      },
    ],
   
    "Traditional Sales": [
      {
        question: "How do I make an offer on a property?",
        answer:
          "To make an offer on a property listed on Twoffers, you must first register on Twoffers.com. Once registered, visit the property details page, enter your offer amount, and click on 'Place Offer'. All offers must be submitted directly through the Twoffers website. Sellers will not consider offers sent via fax or email.",
      },
      {
        question: "What is a list price?",
        answer:
          "The list price is the amount the seller believes the property is worth and is likely to accept. You may submit an offer below the list price, but the seller is not obligated to accept it.",
      },
      {
        question: "Does the seller have to accept the highest offer?",
        answer:
          "No, the seller can accept or reject any offer. Decisions are based on multiple factors, including financing type, closing date, and other terms. In the case of short sales, both the seller and the seller’s lender must approve the offer.",
      },
      {
        question:
          "Can you keep my offer as a backup if the property goes under contract with a different offer?",
        answer:
          "Yes. During the offer process, you can check the box that says 'If the seller accepts another offer for this property, please hold my offer terms as a backup for __ days' and specify the number of days. This allows your offer to remain active as a backup in case the current contract falls through. However, the seller is not obligated to accept or review backup offers.",
      },
      {
        question:
          "What happens if I have a backup offer and the current contract falls through?",
        answer:
          "If the current contract with another buyer falls through, the seller may review the backup offers and choose one to move forward with or reject them all. The decision rests entirely with the seller.",
      },
      {
        question: "Can I submit my offer subject to a contingency?",
        answer:
          "Most Offers on Twoffers are sold 'As-Is,' meaning no contingencies are allowed. However, some sellers may offer limited contingencies or concessions, which are displayed on the third page of the offer process. Review these details carefully before submitting your offer.",
      },
      {
        question:
          "How do I respond to the seller's request for different terms?",
        answer:
          "You will receive an email from Twoffers detailing the seller’s requested changes along with a link to respond. You can choose to accept, decline, or propose alternative terms. It’s also recommended to check your 'My Twoffers' account to ensure you receive these notifications promptly.",
      },
      {
        question: "What does 'Highest and Best' mean?",
        answer:
          "When there are multiple offers on a property, the seller may request all interested buyers to submit their 'Highest and Best' offer by a specific deadline. You will receive an email invitation if you have already submitted an offer. After the deadline, the seller reviews all submissions and decides how to proceed. Note: If you don’t submit a Highest and Best offer, your most recent offer will be considered final. The seller is not obligated to accept any offer.",
      },
      {
        question:
          "How do I respond to the Highest and Best offer request from the seller?",
        answer:
          "If you’ve already placed an offer, you’ll receive an email from Twoffers with a link to submit your final offer. Other buyers can also use the 'Place Offer' button on the property page to submit their Highest and Best offer. You can also find these details in your 'My Twoffers' account.",
      },
      {
        question: "Will Highest and Best offers be posted on the site?",
        answer:
          "Highest and Best offers are not displayed on the website until the seller approves one. Once approved, it will appear as the 'Current Highest Offer' on the property details page.",
      },
      {
        question: "Can I withdraw my offer?",
        answer:
          "Yes, you can withdraw active or backup offers. To do this, log in to your 'My Twoffers' account, go to 'Manage' under Active Offers, and click 'Withdraw' next to the offer you wish to retract. However, once the seller has approved your offer, it becomes binding and cannot be withdrawn.",
      },
      {
        question: "Why was my offer rejected?",
        answer:
          "Offers may be rejected for two main reasons: 1. Another buyer submitted an offer with a higher price or better terms (e.g., fewer contingencies or a faster closing date). 2. The offer did not meet the seller’s requirements. In short sales, the lender may also decline the offer and will only disclose the reason to the seller or their agent.",
      },
    ],
    "Non Performing Loans": [
      {
        question: "What is a non-performing loan?",
        answer:
          "A non-performing loan (NPL) is a delinquent first mortgage secured by a vacant or occupied property where the borrower has failed to make scheduled mortgage payments for a certain period of time. These loans may be in the pre-foreclosure stage, or foreclosure proceedings might have already started but not yet reached a foreclosure sale.",
      },
      {
        question:
          "How do I find out where the property is in the foreclosure process?",
        answer:
          "You can check the foreclosure status directly on the property details page for the non-performing loan. You can also fill out the inquiry form on the property page and ask your assigned Twoffers representative for detailed information about the foreclosure status.",
      },
      {
        question: "Why do lenders sell non-performing loans?",
        answer:
          "Once a loan becomes non-performing, the chances of full repayment decrease significantly. Selling the loan allows the lender to recover some or all of the unpaid amount, generate liquidity, and avoid the costs and delays of foreclosure. Buyers often acquire these loans at a discounted price, providing potential investment opportunities.",
      },
      {
        question:
          "How does acquiring a non-performing loan differ from acquiring an REO?",
        answer:
          "When you buy an REO (Real Estate Owned) property, you acquire the actual physical property. When you buy a non-performing loan, you acquire the mortgage note secured by the property, giving you the same rights, responsibilities, and benefits as the original lender.",
      },
      {
        question: "What happens if my offer is accepted by the lender?",
        answer:
          "If the lender approves your offer, they will work with you to complete the closing process. You should be prepared to wire the full purchase price. After closing, you’ll collaborate with a designated law firm to appoint a receiver (if necessary) and continue the foreclosure process. Once foreclosure is complete, you may choose to retain or sell the property.",
      },
      {
        question: "Why do I need a receiver?",
        answer:
          "A court-appointed receiver may be required to handle repairs, collect rent, or manage the property before foreclosure is finalized. The receiver is typically a local real estate agent, property manager, or contractor appointed by the court. The process varies by jurisdiction, and any funds collected by the receiver are distributed according to court direction, with maintenance and repair costs usually covered first.",
      },
      {
        question: "Who will service the loan after I purchase it?",
        answer:
          "After the transaction is closed, a pre-approved loan servicer will be assigned to manage the servicing of your non-performing loan.",
      },
      {
        question: "Do I pay a fee to purchase a non-performing loan?",
        answer:
          "Yes, purchasing a non-performing loan includes a program fee equal to 5% of the total purchase price or ₹2,500 — whichever is greater. This fee is added to the purchase price and paid at closing. A portion of this fee goes to Twoffers as compensation for marketing and platform services.",
      },
      {
        question: "Can I view listings before paying the program fee?",
        answer:
          "Yes, you can freely view and search all non-performing loan listings on Twoffers. The program fee only applies when you purchase a non-performing loan.",
      },
      {
        question: "Can I finance a non-performing loan purchase?",
        answer:
          "In some cases, financing may be available for purchasing non-performing loans. Please contact your assigned Twoffers representative for more information about financing options.",
      },
    ],
    "Before Your Offer/Offer": [
      {
        question:
          "Can I use my real estate agent to assist with the Offer/offer process?",
        answer:
          "Yes, real estate agents can register with Twoffers and submit Offers on behalf of their clients. Agents must be actively licensed in the state where the property is located. Qualified agents are paid commission on the selected Offer amount in cooperation with the listing broker. Commission information is available in the applicable Multiple Listing Service (MLS) listing or by calling the listing agent.",
      },
      {
        question: "Do I need a real estate agent to place a Offer?",
        answer:
          "No, you can place a Offer or submit an offer on Twoffers with or without an agent. If you'd like to work with an agent, include their information when you Offer to ensure they receive their commission. Visit our blog to learn more about the process of working with an agent or buying on your own.",
      },
      {
        question: "What does it mean when a property is subject to redemption?",
        answer:
          "Redemption is a former owner's legal right to reclaim their property via payment — typically the entire loan amount plus fees — within a specified time after foreclosure. Each state's and county's redemption laws and timelines may vary, so consult a real estate attorney for more information. Buyers should note that even after closing, title may not transfer free and clear until the redemption period expires. The buyer may not take possession until that period ends or terminates under applicable state and local laws. There’s also a chance the former owner may exercise their redemption rights and attempt to repurchase the property. It’s best to consult a real estate attorney to understand the risks before   Offer.",
      },
      {
        question: "How do I know if the property is subject to redemption?",
        answer:
          "If a home is subject to a redemption period, it will be listed in the Special Servicing Conditions (Special Terms) section of the property details.",
      },
      {
        question:
          "What does 'Offer review required. Sold subject to seller approval' mean?",
        answer:
          "Some properties listed on Twoffers will include a 'Offer review required. Sold subject to seller approval' label in their description. This means the seller will review Offer results after the Offer concludes and decide whether to accept the highest Offer, even if it doesn’t meet their reserve price. After this review, the seller may choose to proceed with one of the Offerders or relist the property for another Offer cycle. The decision to proceed is solely at the seller’s discretion, so always place your highest and best Offer.",
      },
    ],
    "Buying Without an Agent": [
      {
        question:
          "I'm not using a real estate agent. Can I still tour a home I found on Twoffers?",
        answer:
          "Yes! After selecting the location for your property search, simply check the box next to 'Self-Showing Enabled' under the More Filters tab. This will display any properties in the search area that are equipped with self-showing lockboxes. You can tour these properties anytime without an agent by calling for the access code upon arrival. Please make sure you take note of the occupancy status before visiting a property. Occupied properties will not have self-showing lockboxes and should not be visited. For more information about self-showing lockboxes, visit our blog.",
      },
      {
        question:
          "How do I gain access to a property if I don't have a real estate agent?",
        answer:
          "If the property supports self-showings, you can gain access via a lockbox. Once you've registered your Twoffers account, you can call for an access code when you're ready to tour the home. Some properties may not allow interior access, while others require a real estate agent. To find out if the home supports self-showing, visit the property details page and look for the orange key icon or the orange 'Self Showing' tag. Check out our blog to learn how to Offer and buy property without an agent.",
      },
      {
        question: "What does 'Self-Showing' mean?",
        answer:
          "While traditional real estate lockboxes can only be opened by a licensed agent, select properties on Twoffers are equipped for self-showing. This allows registered Twoffers users to access the property directly. You don’t need to schedule an appointment — once your account is registered, you can call for an access code anytime. Learn more about self-showing properties on our blog.",
      },
    ],
    "Paying for Your Home": [
      {
        question:
          "Is there anything else I should do before I make an offer or Offer on a property?",
        answer:
          "If you're financing your purchase, get pre-approved (not just pre-qualified) for a loan. Pre-approval will help you know how much you can afford and possibly speed up offer acceptance in a competitive market. Also, set aside money in advance for the earnest money deposit and budget for possible home repairs. Knowing how much you're willing to spend on repairs will help you make informed decisions when viewing properties.",
      },
      {
        question: "Can I finance the purchase of the property on this site?",
        answer:
          "In most cases, yes; however, the seller determines whether or not financing is accepted. If financing is not accepted, the buyer must pay cash for the property. Look for 'Financing Considered' or 'Cash Only' under the Place Offer or Make Offer button on each property details page. Hover over 'Financing Considered' to see which types of financing the seller will allow. Note: Not all properties will qualify for loans; check with your lender to confirm.",
      },
      {
        question:
          "What's the difference between   Offer on a property and making an offer?",
        answer:
          "When you Offer on a property, you're participating in an Offer with a set time limit. When you make an offer on a property, you're engaging in a traditional sale process that has no time limit. The Offer format typically moves faster, while the traditional offer process allows more flexibility for negotiation.",
      },
      {
        question: "What is the transfer tax?",
        answer:
          "A transfer tax is a fee charged to the buyer when the title of a property is transferred from the seller to the buyer. Depending on the location, the transfer tax may include documentary stamp taxes, excise taxes, or deed transfer taxes. If applicable, the transfer tax details will be included in the purchase and sale agreement you receive before closing.",
      },
    ],
    Registration: [
      {
        question: "How do I register with Twoffers?",
        answer:
          "Click 'Register' in the upper right-hand corner of the page. Fill out the form and submit your information to get registered on Twoffers.",
      },
      {
        question:
          "Do I need to register to Offer or make an offer on a property?",
        answer:
          "Yes, you need to register and verify your credentials to make an offer or place a Offer on a property listed on Twoffers.",
      },
      {
        question:
          "Why do you ask for the last four digits of my Social Security number, and how do you protect this information?",
        answer:
          "We require the last four digits of your Social Security number as an additional verification step to protect our customers against potential fraud. This information is only used to verify your identity and is not stored for future use. All data you provide is transmitted over an encrypted connection for your security.",
      },
      {
        question: "Why do you have to verify my information?",
        answer:
          "As an online real estate marketplace, Twoffers must ensure that all buyers and sellers are valid and contactable parties during the   Offer, offer, and closing process. Verification helps protect everyone involved from potential fraud.",
      },
      {
        question: "After I register, how do I change my user information?",
        answer:
          "To update your profile information, sign in and go to the 'My Profile' section of your Twoffers account. Update the necessary fields and click 'Save' at the bottom of the page.",
      },
      {
        question: "What do you do with the information I enter?",
        answer:
          "Your information is used solely to verify your identity. Twoffers does not store your Social Security number or date of birth, and this data is deleted immediately after your identity is confirmed.",
      },
      {
        question:
          "Will I have to go through this process every time I log in to Twoffers?",
        answer:
          "No. This is a one-time verification process. Once your information has been successfully verified, you won’t need to repeat it during future logins.",
      },
    ],
    "Search/Favorites": [
      {
        question: "How do I view my recent searches?",
        answer:
          "Twoffers saves the last few searches you've made, even if you are not logged in. You can view your recent search terms just below the search bar on the homepage.",
      },
      {
        question: "How do I save my searches?",
        answer:
          "After performing or refining a search, click the 'Save Search' button located toward the upper right-hand corner of the search results page. You can also edit and name your saved search for easier reference in the future.",
      },
      {
        question:
          "How can I receive email alerts regarding properties that meet the criteria in my saved searches?",
        answer:
          "You can receive email alerts when new properties match the criteria of your saved searches. To manage this, go to the 'Saved Search' table in your Buyer Dashboard and edit the notification settings to choose how frequently you'd like to receive alerts.",
      },
      {
        question: "What is the Favorite feature?",
        answer:
          "The 'Favorite' feature on Twoffers helps you stay updated about any changes to a property's status through real-time email notifications.",
      },
      {
        question: "How does the Favorite feature work?",
        answer:
          "Click the 'Favorite' button on a property's search results page or details page to add it to your 'Favorite Properties' list in your My Twoffers account. To manage these alerts, go to the 'Favorites' tab under your My Twoffers account. While we strive to send email updates as soon as a property's status changes, we recommend visiting the property details page on Twoffers frequently for the most up-to-date information, especially when an Offer cycle is close to ending.",
      },
    ],
    "Visiting a Property & Home Inspections": [
      {
        question: "How do I visit the property?",
        answer:
          "The property details page on Twoffers will show whether the property is available for showings. Note: Some bank-owned and foreclosure properties may still be occupied. Attempting to visit or inspect these properties could be considered trespassing. To schedule a visit: If you're working with a real estate agent, ask them to arrange the showing. They can obtain the property access code from Twoffers by selecting 'Get Access Code' on the property details page or through the MLS listing. If you’re not working with an agent, click 'Schedule a Visit' on the property details page and provide your contact information. Our referral agent will reach out to you to schedule a showing.",
      },
      {
        question:
          "Should I inspect the property before   Offer or making an offer?",
        answer:
          "Yes, we highly recommend inspecting the property before placing a Offer or making an offer. Offer properties usually do not include an inspection contingency period, so visiting beforehand helps you make an informed decision. For traditional sales, you may have a seven-day inspection contingency period, but inspecting early is always beneficial.",
      },
      {
        question: "How and when do I schedule an inspection?",
        answer:
          "Each property may have different inspection guidelines. Please review the inspection terms mentioned in the Purchase and Sale Agreement (PSA) and, if applicable, the PSA Addendum for complete details on how and when to schedule an inspection.",
      },
      {
        question: "Am I able to access a property without an agent?",
        answer:
          "For safety and security reasons, all property visits must be accompanied by a licensed real estate agent. If you’d like to arrange a visit, click the 'Schedule a Visit' option on the property details page to request an in-person showing with an agent. You can also contact the listing agent directly using the contact information displayed in the 'Listed by' section on the property details page.",
      },
      {
        question:
          "If the water is turned off, can I have water service activated during inspection?",
        answer:
          "No, water activation is not permitted during property inspections. However, you can hire a licensed plumber to conduct a pressurized air test to verify the plumbing system’s condition without affecting winterizations.",
      },
      {
        question: "What is an occupied property?",
        answer:
          "An occupied property is one where the seller believes that one or more individuals are currently living in the home.",
      },
      {
        question: "How do I know if a property is occupied?",
        answer:
          "Twoffers clearly marks whether a property is occupied. You can find this information directly in the search results or on the property details page.",
      },
      {
        question: "Can I visit an occupied property?",
        answer:
          "No, visiting an occupied bank-owned property is strictly prohibited. Attempting to access or inspect an occupied property may be considered trespassing.",
      },
    ],
    Offers: [
      {
        question: "What is a reserve price?",
        answer:
          "A reserve price is the minimum amount the seller is willing to accept for the property during an Offer. The reserve price is set by the seller and is not displayed to buyers. However, the property details page on Twoffers will indicate whether the reserve price has been met.",
      },
      {
        question: "What is a Competing Offer?",
        answer:
          "Except where prohibited by law, the seller retains the right to place counter Offers on any property listed on Twoffers up to the reserve price. The purpose of these counter Offers is to help Offers reach the reserve price. Where required by law, such counter Offers do not result in the sale of the property. These Offers are known as 'Competing Offers.' For more details, please review our Terms & Conditions.",
      },
      {
        question: "Does Twoffers perform or allow shill   Offer?",
        answer:
          "No. Twoffers strictly prohibits and does not engage in shill   Offer. Shill   Offer refers to the act of placing fake Offers to artificially increase the final sale price of a property.",
      },
      {
        question: "What is the selected Offer in an Offer?",
        answer:
          "A selected Offer can be: (1) The highest Offer at the end of the Offer that meets or exceeds the reserve price, (2) A Offer made for the 'End the Offer Now' price, or (3) Any Offer selected by the seller. The seller may select a lower Offer if it offers better terms such as cash payment or financing that they find more favorable. For short sales, both the seller and their lender must approve the selected Offer.",
      },
      {
        question:
          "What does it mean if a customer 'falls out' or a sale experiences 'fallout'?",
        answer:
          "Fallout occurs when a buyer’s Offer is selected but they fail to complete the closing process. Since the purchase does not finalize, the sale 'falls out' of contract.",
      },
      {
        question: "How do I avoid fallout?",
        answer:
          "Before placing a Offer or offer, ensure that you’re fully prepared to complete the purchase. Once placed, Offers can only be withdrawn by Twoffers Customer Care while the Offer is active, and offers can only be withdrawn before the seller accepts them. Make sure your financing or funds are ready, monitor your email for important notifications (including your spam/junk folder), and frequently check your 'My Twoffers' dashboard. Repeated fallout incidents may result in suspension or termination of your Twoffers account.",
      },
      {
        question: "What is a backup Offer and how do I place one?",
        answer:
          "A backup Offer is placed when an Offer has ended and the property is under contract. It allows you to express continued interest in case the first contract falls through. You can place a backup Offer either during the Offer or afterward by selecting 'Place Backup Offer' and following the prompts. Your Offer deposit hold will be reauthorized on your credit card and will remain until your backup Offer expires or is accepted. If selected, your deposit will be released once your signed Purchase and Sale Agreement (PSA) and Earnest Money Deposit (EMD) are confirmed.",
      },
      {
        question:
          "What happens if I have a backup Offer and the contract with another Offerder falls through?",
        answer:
          "If the initial contract fails, the seller may review all backup Offers and decide whether to proceed with one or reject them all. The decision is entirely at the seller’s discretion.",
      },
      {
        question: "What is the Buyer's Premium?",
        answer:
          "The Buyer's Premium is a fee paid by the buyer at closing. This fee helps cover Twoffers’ marketing and Offer hosting costs. If applicable, details about the Buyer’s Premium will be shown in the Property Fees tab on the property details page and in notifications sent during the   Offer and closing process.",
      },
      {
        question:
          "Does the calculation of the Buyer's Premium change if the purchase price is renegotiated?",
        answer:
          "No. The Buyer’s Premium is always calculated based on the original selected Offer amount as stated in the Purchase and Sale Agreement (PSA), even if the final purchase price changes.",
      },
      {
        question:
          "I was the highest Offerder and met the reserve price, but I wasn’t selected. How is that possible?",
        answer:
          "The reserve price represents the minimum amount a seller may consider, but sellers are not obligated to accept Offers that meet it. Sellers may accept, reject, or negotiate Offers at their discretion. Meeting the reserve price increases your chances, but it does not guarantee selection.",
      },
      {
        question:
          "What happens if the Offer ends and the reserve price isn’t met?",
        answer:
          "If the Offer ends without meeting the reserve price, there is no selected Offerder. However, the seller may choose to negotiate with Offerders, accept a lower offer, or relist the property for a future Offer.",
      },
      {
        question: "Does the seller have to approve the highest Offer?",
        answer:
          "No. Sellers can accept or reject any Offer based on terms such as financing type, deposit, and closing date. In the case of short sales, both the seller and the lender must approve the highest Offer.",
      },
      {
        question: "What is Auto Offer?",
        answer:
          "Auto Offer allows you to stay competitive without monitoring the Offer constantly. You set a maximum amount you’re willing to Offer, and the system automatically increases your Offer in small increments whenever someone else Offers higher—until your maximum is reached.",
      },
      {
        question:
          "What happens if two Offers of equal amounts are received at the same time?",
        answer:
          "Twoffers records all Offers with precise timestamps, so two Offers are never identical in timing. If an auto Offer matches a manual Offer, the auto Offer will take precedence since it was entered earlier. The seller still retains the right to decide which Offer to accept.",
      },
      {
        question: "What is 'End the Offer Now'?",
        answer:
          "'End the Offer Now' allows a Offerder to purchase a property immediately by paying a seller-specified price, ending the Offer instantly.",
      },
      {
        question:
          "Why do some properties have 'End the Offer Now' and others don’t?",
        answer:
          "This feature is available only on select Offer properties. It’s entirely up to the seller to enable or disable this option during the Offer.",
      },
      {
        question: "Why did the 'End the Offer Now' button disappear?",
        answer:
          "The seller may have decided to remove this option. Since it’s controlled by the seller, it can be turned off or on at any time.",
      },
      {
        question:
          "What happens if someone outOffers me right before the Offer ends?",
        answer:
          "This practice is known as 'Offer sniping'—placing a last-second Offer to prevent others from responding. To ensure fairness, Twoffers automatically extends the Offer by 15 minutes whenever a last-minute Offer is placed. Each new Offer resets the 15-minute timer until no new Offers are received. While email alerts are sent for these extensions, we recommend keeping an eye on your 'My Twoffers' dashboard as the Offer nears its end.",
      },
    ],
    "Offer Deposit Hold": [
      {
        question: "What is a Offer deposit?",
        answer:
          "The Offer deposit is a hold placed on your credit card before you can place a Offer on applicable properties on Twoffers. This ensures that only serious Offerders participate in the Offer process. A Offer deposit hold is required once for every applicable property.",
      },
      {
        question: "Why is there a Offer deposit hold?",
        answer:
          "The Offer deposit hold helps confirm that the   Offer pool consists of genuine and committed Offerders with the intent to purchase the property.",
      },
      {
        question: "Is the Offer deposit refundable?",
        answer:
          "The Offer deposit is a hold, not a charge. If you are not the selected Offerder, the hold will be removed within 4–7 business days after the Offer ends. If you are selected, the deposit will be released once your earnest money deposit (EMD) is confirmed by the escrow agent. If you fail to deliver your EMD on time, the hold will be converted into a non-refundable charge.",
      },
      {
        question: "How long does the Offer deposit hold remain?",
        answer:
          "The hold stays in place for the entire Offer cycle. If you’re not the selected Offerder, it’s removed within 4–7 business days after the Offer ends. If you’re selected, it’s released once your EMD is confirmed by the third-party escrow agent.",
      },
      {
        question: "Is a new Offer deposit required for each property?",
        answer:
          "Yes. A separate Offer deposit hold is required for each applicable property you wish to Offer on.",
      },
      {
        question: "Can I withdraw the Offer deposit hold during the Offer?",
        answer:
          "No. Once placed, the Offer deposit hold remains active until the end of the Offer cycle, even if you don’t place any Offers. Please ensure you intend to participate before completing the Offer deposit process.",
      },
      {
        question:
          "What if I am the selected Offerder and don’t make the earnest money deposit?",
        answer:
          "If you fail to submit your earnest money deposit within the required timeframe, your Offer deposit hold will be converted into a non-refundable charge on your credit card.",
      },
      {
        question: "What is the $0.5 non-refundable verification charge?",
        answer:
          "This one-time non-refundable $0.5 charge helps verify your intent as a genuine Offerder. It’s separate from the Offer deposit hold.",
      },
      {
        question:
          "Why was another Offer deposit hold placed on my card for the same property?",
        answer:
          "This can happen if the Offer requires reauthorization of the original Offer deposit or if you’ve placed a backup Offer or offer after the Offer ends. The new hold replaces the old one and remains in place until your backup Offer expires or is accepted.",
      },
    ],
    "Offer Selected/Offer Approved": [
      {
        question:
          "How long does it take for the seller to accept my Offer or offer?",
        answer:
          "Typically, sellers respond within a few days. However, short sale Offers or offers may take significantly longer due to lender review. Properties with Special Conditions or short sales usually have longer response times than Offers or traditional sales.",
      },
      {
        question: "What happens if my Offer is selected?",
        answer:
          "For most bank-owned homes, you’ll receive an email within 48 hours with the name of your Document Processor—your guide through the closing process—and next steps. You can also view this email in your My Twoffers account. Note: An email does not constitute final acceptance. The Purchase and Sale Agreement (PSA) must be fully signed for acceptance to be final. For short sales or properties with Special Terms, you’ll receive an email outlining the next steps in the contract process.",
      },
      {
        question:
          "What should I do after I am the selected Offerder or my offer is approved?",
        answer:
          "If you are the selected Offerder in an Offer or your offer is approved, you’ll receive an email containing a link to digitally sign the Purchase and Sale Agreement (PSA). You must review, sign, and confirm it within 48 hours. For some properties, the PSA may be sent as an attachment, and you must sign and upload it through the provided link within 48 hours. For short sales or properties with Special Terms, you’ll receive further instructions on the next steps.",
      },
      {
        question: "When is the Purchase and Sale Agreement (PSA) signed?",
        answer:
          "For most bank-owned homes, after receiving notification that your Offer is selected, you’ll receive instructions via email on how to complete and submit the PSA. You must sign the PSA within 48 hours. Note: The Offer is not considered accepted until all required signatures are completed. The seller may continue to receive backup Offers or offers. For short sale or special condition properties, the buyer and their agent work directly with the listing agent to sign the PSA, and an additional PSA Addendum may be required.",
      },
      {
        question:
          "What if I don’t sign and return the Purchase and Sale Agreement (PSA) within 48 hours?",
        answer:
          "If you fail to sign and return the PSA within 48 hours, the seller may cancel your offer or Offer. For short sales or properties with Special Terms, the listing agent is responsible for informing the buyer of signing requirements. Failure to return the PSA on time may result in the suspension of your Twoffers account.",
      },
      {
        question: "What are the earnest money deposit requirements?",
        answer:
          "For most bank-owned homes, the earnest money deposit ranges from 1% to 7% of your selected Offer or offer amount, but it’s never less than $1,000 or more than $15,000. This amount will be applied to the purchase price at closing. You can view the exact percentage on the property’s details page. If you fail to comply with the terms of the PSA, your earnest money deposit may be forfeited. For properties with Special Terms, the amount is determined by the seller and specified in the PSA.",
      },
      {
        question: "Where should I send the earnest money deposit?",
        answer:
          "The Closing Agent (Closing Attorney, Title Company, or Escrow Office) listed in the Purchase and Sale Agreement (PSA) must receive your earnest money deposit within 48 hours after you receive the fully executed PSA. Refer to the PSA for exact details. For Special Terms properties, the PSA specifies where to send the deposit.",
      },
    ],
    Closing: [
      {
        question: "If a house needs repairs, can I make them before I close?",
        answer:
          "No, repairs cannot be made until you officially own the property on Twoffers.",
      },
      {
        question:
          "Can I choose my Title Company, Closing Attorney, Escrow Agent or Closing Agent?",
        answer:
          "Yes, you can. However, the seller may offer certain incentives if you use their preferred Title Company, Closing Attorney, Escrow Agent or Closing Agent. For cash purchases, some sellers may reserve the right to choose who will handle the title or closing. Please check your Purchase and Sale Agreement (PSA) for more details.",
      },
      {
        question: "Does the seller provide marketable title at closing?",
        answer:
          "The seller makes every effort to provide the property with a marketable title. Any questions related to title issues are reviewed on a case-by-case basis, according to the Purchase and Sale Agreement.",
      },
      {
        question: "What is a title search and why is it important?",
        answer:
          "A title search ensures that the seller has the legal right to sell the property and identifies any potential claims or restrictions that could affect ownership. This includes reviewing public records from municipal and county offices. Note: The title process for bank-owned or short-sale homes may take longer, so buyers should allow sufficient time for review and issue resolution.",
      },
      {
        question: "How can I tell if there are any liens against a property?",
        answer:
          "Unless otherwise stated in the property’s document section, liens are typically discovered during the title search process.",
      },
      {
        question: "What closing costs am I responsible for paying?",
        answer:
          "The Purchase and Sale Agreement (PSA) outlines which closing costs are the responsibility of the buyer and which are covered by the seller. Please refer to your PSA for details.",
      },
      {
        question: "When will I close on the property?",
        answer:
          "The closing timeline depends on the sale type (Offer or traditional), financing terms, and the agreed-upon target closing date between you and the seller.",
      },
      {
        question:
          "What happens to my earnest money deposit if I fail to close on a property after signing the PSA?",
        answer:
          "If you fail to close after signing the Purchase and Sale Agreement (PSA), your earnest money deposit may be forfeited unless the failure to close is due to a verified issue caused by the seller. Review your PSA for exact terms.",
      },
      {
        question: "Will I need to purchase flood or homeowner’s insurance?",
        answer:
          "If you finance your purchase, most lenders will require you to obtain hazard and, in some cases, flood insurance depending on the property’s location. Even for cash purchases, insurance is strongly recommended. Please confirm your insurance requirements before placing a Offer or offer on Twoffers.",
      },
    ],
    eSignatures: [
      {
        question: "What is eSignature?",
        answer:
          "eSignature refers to the secure digital technology that allows users to sign contracts and documents online. Twoffers uses eSignature paperless functionality through DocuSign for many of our transactions—from Listing Agreements signed by agents to the Purchase and Sale Agreement (PSA) signed during closing. Using DocuSign eliminates the need to print, hand-sign, and mail or fax paperwork. Availability of eSignature functionality may vary by state.",
      },
      {
        question: "What is DocuSign?",
        answer:
          "DocuSign is a trusted provider of web-based electronic signature technology that enables users to securely sign and exchange legal documents, contracts, and agreements online. It helps eliminate paper-based processes by keeping track of document versions and ensuring fast, secure, and traceable completion.",
      },
      {
        question:
          "How do I use DocuSign when purchasing or selling through Twoffers?",
        answer:
          "When you're involved in eligible transactions on Twoffers, you'll receive an email link to access documents on DocuSign. You can review and sign them digitally. Once all parties have completed their electronic signatures, the final signed copies are automatically sent to everyone involved via email. If you need additional guidance, you can view DocuSign’s official tutorial video.",
      },
      {
        question: "How do I fax using DocuSign?",
        answer:
          "If you prefer to fax instead of signing digitally, DocuSign provides a fax option. Simply follow the fax instructions included in the DocuSign program to send your signed documents back to the Document Processor securely.",
      },
      {
        question: "What documents are being sent through DocuSign?",
        answer:
          "If you are located in a state where Twoffers currently uses DocuSign, you’ll receive the PSA (Purchase and Sale Agreement) bundle—including the main agreement and related disclosures—through DocuSign.",
      },
      {
        question:
          "What is the time limit for me to sign documents in DocuSign?",
        answer:
          "Once you receive your DocuSign link, you have 48 hours to review, sign, and confirm your documents.",
      },
      {
        question: "How do I start using DocuSign?",
        answer:
          "If you’re a buyer in a state where Twoffers uses DocuSign, you’ll receive an email notification after your Offer or offer is accepted. This email will include details about your PSA bundle and may also include a separate DocuSign request for contact information needed to complete the Purchase and Sale Agreement. Referral agents listing properties on Twoffers will also receive Listing Agreements and addendums via DocuSign in applicable states.",
      },
      {
        question:
          "If I receive my Purchase and Sale Agreement (PSA) through DocuSign, do I have to electronically sign it or can I fax it?",
        answer:
          "We highly recommend completing your PSA digitally using DocuSign for a faster and more secure process. However, a ‘Send by Fax’ option is available. If you choose to fax, DocuSign will provide a specific fax number and cover sheet. Be sure to use the provided U.S. fax number—other numbers may not complete your process successfully.",
      },
      {
        question: "How can I access previously signed documents in DocuSign?",
        answer:
          "If you need to view or download documents you've already signed via DocuSign, simply follow the access instructions included in your DocuSign confirmation emails or visit your DocuSign account directly.",
      },
      {
        question:
          "Where can I find more information about DocuSign and the eSignature process?",
        answer:
          "You can learn more by visiting the Twoffers Paperless Process User Guide, which provides detailed information about DocuSign and our eSignature procedures.",
      },
    ],
    "Proof of Funds": [
      {
        question: "I am being asked to provide Proof of Funds. What is this?",
        answer:
          "The Proof of Funds process requires prospective buyers to provide evidence that they have sufficient funds to complete the property purchase. It assures the seller that the buyer has the financial capability to successfully close the transaction.",
      },
      {
        question:
          "What information is required to satisfy the Proof of Funds requirement?",
        answer:
          "Each seller’s criteria may vary, but generally, for cash transactions, proof of funds can be provided through a letter from a financial institution confirming that the buyer’s account has sufficient balance to cover the purchase. For financed transactions, proof of funds is typically demonstrated by providing a pre-approval letter from the buyer’s mortgage lender or bank confirming financing availability.",
      },
      {
        question: "When and how do I provide my proof of funds?",
        answer:
          "Prospective buyers must submit their proof of funds as part of the purchase process. Documents can be uploaded either through the Contact Information Form or directly on the Offer confirmation screen when submitting a Offer or offer on Twoffers.",
      },
    ],
  };
  useEffect(() => {
    const firstSidebar = sidebarData[activeTab]?.[0];
    if (firstSidebar) {
      setActiveSidebar(firstSidebar);
      setActiveAccordion(null);
    }
  }, [activeTab]);
  const currentSidebar = sidebarData[activeTab];
  const currentAccordion = accordionData[activeSidebar] || [];
  return (
    <>
      <Header />

      {/* ---- HERO SECTION ---- */}
      <section className="support-hero scrolleffect">
        <div className="support-hero__container">
          <div className="support-hero__left">
            <h1 className="support-hero__title">
              How can we make
              <br />
              your day easier?
            </h1>

            <p className="support-hero__subtitle">
              Find answers in our support library
            </p>
          </div>

          <div className="support-hero__right" aria-hidden="true">
            <div className="support-hero__image-frame">
              <img
                src={Support}
                alt="Support"
                className="support-hero__image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ---- TOP SUPPORT ARTICLES SECTION ---- */}
      <section className="support-articles">
        <div className="support-articles__container">
          <h2 className="support-articles__title">Top Support Articles</h2>
          <p className="support-articles__subtitle">
            Choose a topic below to explore. Still have questions? Use our help
            library to find answers.
          </p>

          <div className="support-articles__grid">
            {articles.map((item, index) => (
              <div
                key={index}
                className="support-article__card"
                onClick={() => setActiveArticle(item)}
              >
                <p>{item.question}</p>
                <button className="support-article__btn">→</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="faq-section">
        <h2 className="faq-title">Frequently Asked Questions</h2>

        {/* ====== Tabs ====== */}
        <div className="faq-tabs">
          {Object.keys(sidebarData).map((tab) => (
            <button
              key={tab}
              className={`faq-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => {
                setActiveTab(tab);
                setActiveSidebar("");
                setActiveAccordion(null);
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="faq-container">
          {/* ====== Sidebar ====== */}
          <div className="faq-sidebar">
            {currentSidebar.map((item) => (
              <div
                key={item}
                className={`faq-sidebar-item ${
                  activeSidebar === item ? "active" : ""
                }`}
                onClick={() => {
                  setActiveSidebar(item);
                  setActiveAccordion(null);
                }}
              >
                {item}
              </div>
            ))}
          </div>

          {/* ====== Accordion Content ====== */}
          <div className="faq-content">
            {activeSidebar ? (
              currentAccordion.length > 0 ? (
                currentAccordion.map((q, index) => (
                  <div key={index} className="faq-accordion">
                    <div
                      className="faq-question"
                      onClick={() =>
                        setActiveAccordion(
                          activeAccordion === index ? null : index
                        )
                      }
                    >
                      <span>+</span> {q.question}
                    </div>
                    {activeAccordion === index && (
                      <div className="faq-answer">{q.answer}</div>
                    )}
                  </div>
                ))
              ) : (
                <p className="no-data">
                  No questions available for this section.
                </p>
              )
            ) : (
              <p className="no-data">Select a category from the sidebar.</p>
            )}
          </div>
        </div>
      </section>

      <section className="support-stats">
        <div className="support-stats__overlay">
          <div className="support-stats__container">
            <div className="support-stats__text">
              <h2>
                Twoffers delivers quality <br />
                homes at unbeatable prices
              </h2>
            </div>

            <div className="support-stats__data">
              <div className="support-stats__item">
                <h3>225,000+</h3>
                <p>Properties Sold</p>
              </div>
              <div className="support-stats__item">
                <h3>1.7+</h3>
                <p>Million Users</p>
              </div>
              <div className="support-stats__item">
                <h3>3,000+</h3>
                <p>Properties Listed at any given time</p>
              </div>
              <div className="support-stats__item">
                <h3>10+</h3>
                <p>Years of Experience</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---- MODAL POPUP ---- */}
      {activeArticle && (
        <div
          className="support-modal-overlay"
          onClick={() => setActiveArticle(null)}
        >
          <div className="support-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="support-modal__close"
              onClick={() => setActiveArticle(null)}
            >
              ✕
            </button>

            <h3 className="support-modal__question">
              💡 {activeArticle.question}
            </h3>

            <div className="support-modal__answer">
              <p className="support-modal__answer-title">💬 Answer</p>
              <p className="support-modal__text">{activeArticle.answer}</p>
            </div>

            <hr className="support-modal__divider" />

            <div className="support-modal__footer">
              <p>Was this information helpful?</p>
              <div className="support-modal__buttons">
                <button
                  className="support-modal__yes"
                  onClick={() => setActiveArticle(null)}
                >
                  ✔ Yes, thanks!
                </button>
                <button
                  className="support-modal__no"
                  onClick={() => setActiveArticle(null)}
                >
                  ✖ Not quite
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}
